import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "minus-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { id: "Web---Filled", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", strokeLinecap: "round" },
        React.createElement("g", { id: "Web/Filled/16x16/minus", stroke: "currentColor", strokeWidth: 1.5 },
            React.createElement("path", { id: "Path-4", d: "M2.75 8.25h11" }))));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
